"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "permissions", {
  enumerable: true,
  get: function get() {
    return _permissions["default"];
  }
});
var _permissions = _interopRequireDefault(require("./permissions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }